import React from 'react';
import { Modal, Form, Button, Row, Col } from 'react-bootstrap';

const EditIndexModal = ({ show, onHide, indexName, configs, handleEditIndex }) => {
  return (
    <Modal size="lg" show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit {indexName}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={(e) => handleEditIndex(e, indexName)}>
          <Row>
            <Col md={6}>
              <Form.Group controlId={`${indexName}-indexExchange`} className="mb-3">
                <Form.Label>Index Exchange</Form.Label>
                <Form.Control
                  type="text"
                  name="indexExchange"
                  defaultValue={configs[indexName]?.indexExchange}
                  placeholder="e.g., NSE or BSE"
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId={`${indexName}-optionsExchange`} className="mb-3">
                <Form.Label>Options Exchange</Form.Label>
                <Form.Control
                  type="text"
                  name="optionsExchange"
                  defaultValue={configs[indexName]?.optionsExchange}
                  placeholder="e.g., NFO or BFO"
                  required
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group controlId={`${indexName}-profitPercentage`} className="mb-3">
                <Form.Label>Profit %</Form.Label>
                <Form.Control
                  type="number"
                  name="profitPercentage"
                  defaultValue={configs[indexName]?.profitPercentage}
                  step="0.05"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId={`${indexName}-lotSize`} className="mb-3">
                <Form.Label>Lot Size</Form.Label>
                <Form.Control
                  type="number"
                  name="lotSize"
                  defaultValue={configs[indexName]?.lotSize}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group controlId={`${indexName}-maxLots`} className="mb-3">
                <Form.Label>Max Lots</Form.Label>
                <Form.Control
                  type="number"
                  name="maxLots"
                  defaultValue={configs[indexName]?.maxLots}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId={`${indexName}-workingFigure`} className="mb-3">
                <Form.Label>Working Figure (Budget)</Form.Label>
                <Form.Control
                  type="number"
                  name="workingFigure"
                  defaultValue={configs[indexName]?.workingFigure}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Form.Group controlId={`${indexName}-symboltoken`} className="mb-3">
                <Form.Label>Symbol Token</Form.Label>
                <Form.Control
                  type="text"
                  name="symboltoken"
                  defaultValue={configs[indexName]?.symboltoken}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId={`${indexName}-step`} className="mb-3">
                <Form.Label>Step Size</Form.Label>
                <Form.Control
                  type="number"
                  name="step"
                  defaultValue={configs[indexName]?.step}
                />
              </Form.Group>
            </Col>
          </Row>
          <div className="mt-3">
            <Button type="submit" className="me-2">Save</Button>
            <Button variant="secondary" onClick={onHide}>Cancel</Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default EditIndexModal;